import { getFirst } from 'clients/Clients';
import { useCart } from 'context/Cart/CartContext';
import { BeVoucher } from 'types/voucher';
import NotifyUtils from 'utils/NotifyUtils';
import { useCartActions } from 'zustand-lib/useCart';

interface Props {
  callback?: () => void;
}

export const useVoucherInfoActions = ({ callback }: Props) => {
  const { reloadDataCart, multiVoucherHandleChangePromoV2 } = useCart();
  const { updateRedeemApplyResult } = useCartActions();

  const onCTAClick = async (actionStatus: BeVoucher['actionStatus'], code: string) => {
    if (actionStatus === 'AVAILABLE') {
      const res = await multiVoucherHandleChangePromoV2([code]);

      if (res.status === 'OK') {
        const { redeemApplyResult } = getFirst(res);
        updateRedeemApplyResult(redeemApplyResult);
        await reloadDataCart({
          cartRes: res,
          successMessage: 'Thêm mã giảm giá thành công',
          errorMessage: 'Thêm mã giảm giá thất bại',
          isReloadData: true,
        });
        callback && callback();
      } else {
        switch (res.errorCode) {
          case 'NOT_FOUND': {
            NotifyUtils.error('Vui lòng thêm ít nhất một sản phẩm vào giỏ hàng và thử lại.');
            break;
          }
          case 'VOUCHER_CODE_INVALID': {
            NotifyUtils.error(res.message);
            break;
          }
          default: {
            NotifyUtils.error('Lỗi! Xin vui lòng kiểm tra lại.');
            break;
          }
        }
      }
    }
  };

  return {
    onCTAClick,
  };
};

